<app-configuration-page
  title="Communication Templates"
  description="Customize the emails and text messages your studio sends to students."
  [breadcrumbs]="[{ label: 'Communication Templates' }]">

  <mat-tab-group
    class="channel-tabs"
    [selectedIndex]="channel === 'email' ? 0 : 1"
    (selectedIndexChange)="changeChannel($event === 0 ? 'email' : 'sms')"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="me-2">email</mat-icon> Email
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="me-2">sms</mat-icon> Text Message (SMS)
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="showProgressSpinner" class="matProgressSpinnerCentered">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <form [formGroup]="form" *ngIf="!showProgressSpinner" class="row">
    <div class="col-md-3 mb-3">
      <mat-card class="templates-sidebar-card">
        <mat-nav-list class="templates-nav">
          <a
            mat-list-item
            *ngFor="let t of templates"
            (click)="selectTemplate(t.key)"
            [class.template-nav-active]="selectedKey[channel] === t.key"
            class="template-nav-link"
          >
            <span
              class="status-dot"
              [class.on]="isEnabled(t)"
              [matTooltip]="isEnabled(t) ? 'Enabled' : 'Disabled'"
            ></span>
            <span class="template-nav-label">{{ t.label }}</span>
          </a>
        </mat-nav-list>
      </mat-card>
    </div>

    <div class="col-md-9">
      <mat-card class="configuration-card">
        <mat-card-content>
          <div class="editor-title-row">
            <div>
              <h2 class="editor-title">{{ selected.label }}</h2>
              <div class="editor-subtitle">{{ selected.description }}</div>
            </div>
            <mat-slide-toggle *ngIf="selected.enableField" [formControlName]="selected.key + '_enabled'">
              {{ isEnabled(selected) ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
          </div>

          <div class="mt-3" *ngIf="successMessage">
            <div class="alert alert-success">{{ successMessage }}</div>
          </div>
          <div class="mt-3" *ngIf="errorMessage">
            <div class="alert alert-danger">{{ errorMessage }}</div>
          </div>

          <div *ngIf="selected.hasIntervals" class="intervals-section">
            <div class="intervals-label">
              When to send
              <span class="text-muted ms-2">(choose one)</span>
            </div>

            <mat-button-toggle-group
              class="intervals-group"
              [value]="selectedInterval()"
              (change)="setInterval($event.value)"
            >
              <mat-button-toggle value="24_hour">24 hours before</mat-button-toggle>
              <mat-button-toggle value="48_hour">48 hours before</mat-button-toggle>
              <mat-button-toggle value="72_hour">72 hours before</mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <ng-container *ngFor="let t of templates">
            <mat-form-field
              *ngIf="t.key === selected.key && t.subjectField"
              class="full-width-field"
              appearance="outline"
            >
              <mat-label>Subject</mat-label>
              <input matInput [formControlName]="t.key + '_subject'">
            </mat-form-field>
          </ng-container>

          <div class="mb-2">
            <strong>Placeholders</strong>
            <span class="text-muted ms-2">Click to insert at cursor</span>
          </div>
          <div class="mb-3">
            <button
              *ngFor="let p of selected.placeholders"
              type="button"
              mat-stroked-button
              class="me-2 mb-2 placeholder-btn"
              (click)="insertPlaceholder(p)"
            >
              {{ p }}
            </button>
          </div>

          <ng-container *ngIf="channel === 'email'">
            <div class="mb-1"><strong>Body</strong></div>
            <ng-container *ngFor="let t of templates">
              <app-rich-text-editor
                *ngIf="t.key === selected.key"
                #rte
                [formControlName]="t.key + '_body'"
                placeholder="Type the email body..."
              ></app-rich-text-editor>
            </ng-container>
            <small class="text-muted d-block mt-1">The studio's email layout (logo, footer) wraps this content automatically.</small>
          </ng-container>

          <ng-container *ngIf="channel === 'sms'">
            <div class="d-flex justify-content-between align-items-end mb-1">
              <strong>Body</strong>
              <small class="text-muted">
                {{ smsBodyLength() }} characters · {{ smsSegments() }} SMS segment{{ smsSegments() === 1 ? '' : 's' }}
              </small>
            </div>
            <ng-container *ngFor="let t of templates">
              <textarea
                *ngIf="t.key === selected.key"
                [id]="'sms-body-' + t.key"
                class="form-control sms-body-textarea"
                rows="6"
                [formControlName]="t.key + '_body'"
              ></textarea>
            </ng-container>
            <small class="text-muted d-block mt-1">SMS messages over 160 characters are split into multiple segments and may be billed separately.</small>
          </ng-container>
        </mat-card-content>

        <mat-card-actions align="end">
          <button mat-button type="button" (click)="resetToDefault()">
            <mat-icon>restart_alt</mat-icon>
            Reset to default
          </button>
          <button mat-raised-button color="primary" type="button" (click)="save()">
            Save changes
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </form>

</app-configuration-page>
